export enum ClinicStep {
  Organization = 0,
  Location = 1,
  Services = 2,
  Hours = 3,
  Summary = 4,
}
